/**
 * External dependencies
 */
import React from 'react';
import { __ } from '@wordpress/i18n';
// import { useContainerWidthContext } from '@woocommerce/base-context';
// import { Panel } from '@woocommerce/blocks-components';
// import type { CartItem } from '@woocommerce/types';

import {  useContainerWidthContext } from '../../../context';
import { Panel } from '../../../../../packages/components';

import { CartItem } from '../../../../types/type-defs/cart';
/**
 * Internal dependencies
 */
import OrderSummaryItem from './order-summary-item';

import { createRef, useEffect, useRef } from '@wordpress/element';


import './style.scss';
import { CartResponseItem } from '../../../../../../old_wc_components/types/type-defs/cart-response';
import type { RefObject } from 'react';

interface OrderSummaryProps {
	cartItems: CartItem[];
}

const setRefs = ( lineItems: CartResponseItem[] ) => {
	const refs = {} as Record< string, RefObject< HTMLTableRowElement > >;
	lineItems.forEach( ( { key } ) => {
		refs[ key ] = createRef();
	} );
	return refs;
};

const OrderSummary = ( {
	cartItems = [],
}: OrderSummaryProps ): null | JSX.Element => {
	const { isLarge, hasContainerWidth } = useContainerWidthContext();


	// isLarge = true;
	if ( ! hasContainerWidth ) {
		return null;
	}

	const tableRef = useRef< HTMLTableElement | null >( null );
	const rowRefs = useRef( setRefs( cartItems ) );
	useEffect( () => {
		rowRefs.current = setRefs( cartItems );
	}, [ cartItems ] );

	const onRemoveRow = ( nextItemKey: string | null ) => () => {
		if (
			rowRefs?.current &&
			nextItemKey &&
			rowRefs.current[ nextItemKey ].current instanceof HTMLElement
		) {
			( rowRefs.current[ nextItemKey ].current as HTMLElement ).focus();
		} else if ( tableRef.current instanceof HTMLElement ) {
			tableRef.current.focus();
		}
	};
	
	

	return (
		<Panel
			className="wc-block-components-order-summary"
			initialOpen={ isLarge }
			hasBorder={ false }
			title={
				<span className="wc-block-components-order-summary__button-text">
					{ __( 'Order summary', 'woo-gutenberg-products-block' ) }
				</span>
			} 
		>
			<div className="wc-block-components-order-summary__content">
				{ cartItems.map( ( cartItem, i ) => {
					const nextItemKey =
					cartItems.length > i + 1 ? cartItems[ i + 1 ].key : null;
					return (
						<OrderSummaryItem
							key={ cartItem.key }
							cartItem={ cartItem }
							onRemove={ onRemoveRow( nextItemKey ) }
						/>
					);
				} ) }

				{/* SAI */}
			</div>
		</Panel>
	);
};

export default OrderSummary;
